<template>
<div class="flex w-full vx-row no-gutter justify-center">
  <div class="vx-col sm:w-full md:w-full lg:w-3/5">
    <vx-card class="study-card">
      <vs-list>
        <vs-list-header title="원어민의 발음을 듣고 단어를 씁니다." icon-pack="feather" icon="icon-info"></vs-list-header>
        <vs-list-item class="msg-grp-container">
          <vs-chip color="warning mr-0">{{ contentIndex + 1 }} / {{contentsLen}}</vs-chip>
        </vs-list-item>
      </vs-list>

      <div class="lg:p-4 md:p-3 sm:p-2 p-2 rounded-lg mb-base text-center">
        <vs-row class="mb-2" vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">
          <img style="max-height:180px" :src="content.image" >
        </vs-row>  
        <vs-row vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">
              
          <component 
            v-model="item.model" 
            :ref="item.ref" 
            @onEnter="onChildEnter"
            @onKeyup="onChildKeyup"  
            @onBack="onChildBack" 
            @input="onInput" 
            :key="index" 
            v-for="(item, index) in sentenceComponentList" 
            :is="item.input" 
            v-bind="item.props"/>
                
        </vs-row>
      </div>  

      <div class="text-center">
        <audio ref="audioPlayer" 
            controls 
            loop
            hidden
            controlsList="nodownload">Your browser does not support the <code>audio</code> element.
        </audio>
      </div>
    </vx-card>
    <top-button-bar @onReload="onReload" @onNext="onNext" @onFinish="onFinish" @onHint="onHint" ></top-button-bar>
  </div>

</div>
</template>

<script>
import StudyMenuMixin from './StudyMenuMixin'
import TopButtonBar      from './TopButtonBar.vue'
import DictationInput      from './DictationInput.vue'
import DictationLabel      from './DictationLabel.vue'

export default {
  mixins: [StudyMenuMixin],
  components: {
    TopButtonBar,
    DictationInput,
    DictationLabel
  },
  data () {
    return {
      sentenceComponentList: [],
      dictationInputList: [],
      isStart: false,
      contentList: [],
      hint: this.defaultHint,
      contentIndex: 0,
      finished: false,
      modeltest:''
    }
  },
  watch: {
    sourceContent () {
      this.onReload()
    }
  },
  computed: {
    audioPlayer () {
      return this.$refs.audioPlayer
    },
    content () {
      return this.contentList[this.contentIndex]
    },
    sentenceChars () {
      return this.content.sentence.split('')
    },
    sentenceCharsLen () {
      return this.content.sentence.split('').length
    },
    dictationChars () {
      return this.content.dictation.split('')
    }
  },
  methods: {
    onReload () {
      this.audioPlayer.pause()
      //this.hint = false
      this.isStart = false
      this.contentIndex = 0
      this.resetComponents()
      this.startAlert()
    },
    onStart () {
      this.isStart = true
      this.configSentence()
    },
    onHint () {
      for (let i = 0; i < this.dictationInputList.length; i++) {
        this.dictationInputList[i].props.hint = true
      }
    },
    resetComponents () {
      this.sentenceComponentList = []
      this.dictationInputList = []
    },
    startAlert () {
      this.startStudyDlg('원어민의 발음을 듣고 단어를 씁니다.')
    },
    acceptAlert () {
      this.onStart()
    },
    configSentence () {
      
      let inputIndex = 0
      for (let i = 0; i < this.dictationChars.length; i++) {
        if (this.dictationChars[i] !== '_') {
          const conf = {
            data: this.sentenceChars[i]
          }
          const comp = {
            input: DictationLabel, 
            props: conf, 
            model: this.sentenceChars[i],
            answer: this.sentenceChars[i]
          }
          this.sentenceComponentList.push(comp)
          //this.sentenceComponentList.push({ input: DictationLabel, props: conf })
        } else {  
          const conf = {
            hintValue: this.sentenceChars[i],
            hint: this.defaultHint,
            index: inputIndex
          }
          const comp = {
            input: DictationInput, 
            props: conf, 
            model: '',
            value: '', 
            answer: this.sentenceChars[i],
            ref: `input_${inputIndex}`
          }
          this.sentenceComponentList.push(comp)  
          this.dictationInputList.push(comp)
          inputIndex++
        }
      }
      this.audioPlayer.src = this.content.audio
      this.audioPlayer.play()

      setTimeout(function () {
        this.$refs['input_0'][0].focus()
      }.bind(this), 500)

    },
    checkAnswer () {
       
      let correct = true
      for (let i = 0; i < this.dictationInputList.length; i++) {
        const input = this.dictationInputList[i]
        if (input.model !== input.answer) {
          correct = false
          break
        }
      }
      return correct
    },
    makeUserSentence () {
      // 학습자가 입력한 철자로 전체 sentence를 구성한다.
      // Input component의 model에는 학습자가 입력한 철자가 들어있고 Label componentd의 model에는
      // 생성시 설정한 철자가 들어 있다.
      let userAnswer = ''
      for (let i = 0; i < this.sentenceComponentList.length; i++) {
        userAnswer = userAnswer + this.sentenceComponentList[i].model
      }
      return userAnswer
    },
    onChildEnter (index) {

      if (index === this.dictationInputList.length - 1) {
        //정답체크
        if (this.checkAnswer()) {
          this.correct()
        } else {
          this.inCorrect()
          this.retryCount++
          if (this.retryCount < this.retry) {
            setTimeout(function () {
              for (let i = 0; i < this.dictationInputList.length; i++) {
                this.dictationInputList[i].model = ''
              }
            }.bind(this), 1500)
            return
          }
        }
        // question / answer / userAnswer
        this.addResult(this.content.dictation, this.content.sentence, this.makeUserSentence())

        this.audioPlayer.pause()
        if (this.contentIndex < this.contentsLen - 1) {
          setTimeout(function () {
            this.retryCount = 0
            this.contentIndex++
            this.resetComponents()
            this.configSentence()
          }.bind(this), 1500)
        } else {
          this.onComplete()   
        } 
      }
    },
    onInput (value) {
      console.log(value)
    },
    onChildKeyup (index) {
      if (index < this.dictationInputList.length - 1) {
        this.$refs[`input_${  index + 1  }`][0].focus()
      }

      // if (index < this.dictationInputList.length - 1) {
      //   this.$refs[`input_${  index + 1  }`][0].focus()
      // } else if (this.contentIndex < this.contentsLen - 1) {
        
      //   for (let i = 0; i < this.dictationInputList.length; i++) {
      //     console.log(this.dictationInputList[i].model)
      //   }

      //   setTimeout(function () {
      //     this.contentIndex++
      //     this.resetComponents()
      //     this.configSentence()
      //   }.bind(this), 1000)
        
      // } else {
      //   this.audioPlayer.pause()
      //   this.onComplete()
      // }
    },
    onChildBack (index) {
      // if (index !== 0 && this.dictationInputList[index].model.length === 0) {
      //   this.$refs[`input_${  index - 1  }`][0].focus()
      // }
    }
  },
  created () {

    const contentJson = JSON.parse(this.sourceContent.contentBody)

    for (let i = 0; i < contentJson.sentence.length; i++) {
      const content = {
        sentence: contentJson.sentence[i],
        dictation: contentJson.dictation[i],
        audio: this.$buildAudioPath(this.sourceContent.contentCode, i + 1).replace('AP1', 'AP2'),
        image: this.$buildImagePath(this.sourceContent.contentCode, i + 1).replace('AP1', 'AP2')
      } 
      
      this.contentList.push(content)
    }
    this.contentsLen = this.contentList.length
    this.startAlert()
  },
  mounted () {
  }
}

</script>
